import { cn } from '@brew/ui/cn'

export function Highlight({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return (
    <span
      className={cn(
        'p-1 py-0.5 font-medium text-foreground dark:font-semibold',
        className
      )}
    >
      {children}
    </span>
  )
}
